
<div *ngIf="repeatLayout&&value[repeatLayout.fieldName]!=null && value[repeatLayout.fieldName].length>0" class="d-flex flex-column" >
    <!-- <div class="repeat-title d-flex flex-column justify-content-center">
        <div class=" mat-subheading-1 ">{{repeatLayout.name}}</div>
        <div *ngIf="repeatLayout.description" [innerHtml]="repeatLayout.description |safe:'html'">{{repeatLayout.description}}</div>
    </div> -->
    <ng-container *ngFor="let currentValue of value[repeatLayout.fieldName]; let i = index">
        <div class="repeat-title d-flex flex-column justify-content-center">
            <div class=" mat-subheading-1 ">{{repeatLayout.name}} núm. {{i+1}}</div>          
        </div>
        
        <ng-container *ngFor="let data of repeatLayout.items; let index = index">

            <app-dynamic-view-row-layout [layout]="data" [value]="currentValue" [fieldVisibility]="fieldVisibility.get(i)!">

            </app-dynamic-view-row-layout>
        </ng-container>
    </ng-container>
</div>